import React from 'react';
import './styles.scss';

class Button extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            show : false
        }
    }

    showItemButton = (e) => {
        const evt = e.currentTarget.lastChild;
        let check;
        check = evt.classList.contains('showdropdown');
        
        if (evt.nodeName === 'DIV') {
            if (check) {
                evt.style.display = 'none';
                setTimeout(() => {
                    evt.classList.remove('showdropdown');    
                }, 100);
            } else {
            evt.style.display = 'block';
            setTimeout(() => {
                    evt.classList.add('showdropdown');    
                }, 100);
            }
        }
        
        
        if (!this.props.isDropdown) {
            this.props.addData();
        }
    }

    eventItemInButton = (value, key) => {
        this.props.indexEvent(value, key );
    }

    componentDidMount = () => {
        this.commonHideComponent('#btn-add-dropdown', 'dropdown-hidden');
    }


    commonHideComponent = (p, c) => {
        const dropdownHidden = document.getElementById(c);
        if (dropdownHidden) {
            window.addEventListener('click', function (event) {
                if (!event.target.closest(p)) {
                    dropdownHidden.style.display = 'none';
                    setTimeout(() => {
                        dropdownHidden.classList.remove('showdropdown'); 
                    }, 100);
                }
            });
        }
    }


    render() {
        return (
            <div className="content">
                <div className="button-custom" id="btn-add-dropdown" onClick={(e) => this.showItemButton(e)}>
                    {this.props.showIcon ?
                        <div className="img">
                            <img alt="plus" src={this.props.urlIcon ? this.props.urlIcon : '/img/ic_add_svg.svg'} />
                        </div>
                        : null}
                    <span>{this.props.title}</span>
                    {
                        this.props.isDropdown ?
                            <div id='dropdown-hidden'>
                                    <div>
                                        {
                                            this.props.itemDropdown.map((value, key) => (
                                                <button key={key.toString()} onClick={() => this.eventItemInButton(value, key)}>{value}</button>
                                            ))
                                        }
                                    </div>
                            </div> : null
                    }
                </div>
            </div>
        )
    };
}

export default Button;